function getReactNativeWebView() {
  if (typeof window === "undefined") return undefined;
  return window.ReactNativeWebView;
}

export function isReactNativeWebView() {
  return getReactNativeWebView() !== undefined;
}

export class NativeBridge {
  static send(type, payload = {}) {
    const bridge = getReactNativeWebView();
    if (bridge) {
      bridge.postMessage(JSON.stringify({ type, payload }));
    } else {
      console.warn("NativeBridge: not inside React Native WebView");
    }
  }

  /**
   * Listens for messages from RN (`WebView.postMessage` → `document` / `window` `message`).
   * Returns unsubscribe.
   */
  static listen(callback) {
    const handler = (event) => {
      let data = event.data;
      if (typeof data === "string") {
        try {
          data = JSON.parse(data);
        } catch {
          return;
        }
      }
      if (
        data === null ||
        typeof data !== "object" ||
        !("type" in data) ||
        typeof data.type !== "string"
      ) {
        return;
      }
      callback(data);
    };

    document.addEventListener("message", handler);
    window.addEventListener("message", handler);

    return () => {
      document.removeEventListener("message", handler);
      window.removeEventListener("message", handler);
    };
  }
}
